export default __webpack_public_path__ + "static/media/section7.947ee71e.png";